module.exports = __webpack_public_path__ + "static/media/Mitterndorf.58000e50.webp";